<template>
  <section class="why-matters">
    <div class="container">
      <div class="header-content reveal">
        <h2 class="section-title">
          You Shouldn't Have to Choose Between<br />
          <span class="highlight">Running Your Business and Growing It</span>
        </h2>
        <p class="section-desc">
          Bizzento bridges the gap between the daily grind and your long-term
          vision.
        </p>
      </div>

      <div class="benefit-grid">
        <div class="benefit-card reveal delay-1">
          <div class="icon-wrap">
            <div class="icon-bg"></div>
            <span class="benefit-icon">🎯</span>
          </div>
          <h3>Stay Focused</h3>
          <p>
            While Bizzento handles the 24/7 stream of inquiries and bookings, you
            reclaim the mental space to do what you love—bake, create, and
            serve.
          </p>
        </div>

        <div class="benefit-card reveal delay-2">
          <div class="icon-wrap">
            <div class="icon-bg"></div>
            <span class="benefit-icon">📊</span>
          </div>
          <h3>See Clearly</h3>
          <p>
            Stop drowning in spreadsheets. Bizzento translates complex data into
            simple, visual patterns so you always know exactly where your
            revenue is coming from.
          </p>
        </div>

        <div class="benefit-card reveal delay-3">
          <div class="icon-wrap">
            <div class="icon-bg"></div>
            <span class="benefit-icon">💪</span>
          </div>
          <h3>Decide Confidently</h3>
          <p>
            No more "gut-feeling" guesses. Get strategic insights backed by your
            actual business data and industry benchmarks to make moves that
            stick.
          </p>
        </div>
      </div>

      <div class="bottom-cta reveal delay-3">
        <p>Ready to reclaim your time?</p>
        <a href="#waitlist" class="secondary-link">Join the waitlist today →</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhyThisMattersSection',
  /*
    data() {
      return {
        benefits: [
          { number: "01", title: "Personalized Support", text: "We tailor our services to meet individual needs, promoting independence and dignity." },
          { number: "02", title: "Compassionate & Skilled Team", text: "Our experienced professionals provide care with empathy, respect, and dedication." },
          { number: "03", title: "Reliable & Accessible Services", text: "Whether at home or in the community, we’re here when you need us most." },
          { number: "04", title: "Empowering Lives", text: "We foster inclusion, social participation, and opportunities for individuals to thrive." }
        ]
      };
    }*/
};
</script>


<style scoped>
.why-matters {
  /* Theme Variables */
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f5e5b0;
  --dark-accent: #1a1a1a;
  --text-muted: #8e8a82;

  padding: 120px 24px;
  background-color: var(--bg-warm-base);
  color: var(--dark-accent);
  text-align: center;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

.header-content {
  margin-bottom: 80px;
}

.section-title {
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
}

.highlight {
  color: #bfa14d;
}

.section-desc {
  font-size: 1.2rem;
  color: var(--text-muted);
}

.benefit-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
}

.benefit-card {
  background: white;
  padding: 50px 30px;
  border-radius: 40px;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.benefit-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05);
}

/* Icon Styling with Glow */
.icon-wrap {
  position: relative;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-bg {
  position: absolute;
  width: 80px;
  height: 80px;
  background: var(--sunlight-glow);
  border-radius: 50%;
  filter: blur(15px);
  z-index: 1;
}

.benefit-icon {
  font-size: 3rem;
  position: relative;
  z-index: 2;
}

h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 16px;
}

.benefit-card p {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--text-muted);
}

.bottom-cta {
  margin-top: 80px;
  border-top: 1px solid var(--soft-gold);
  padding-top: 40px;
}

.bottom-cta p {
  font-weight: 600;
  margin-bottom: 12px;
}

.secondary-link {
  color: var(--dark-accent);
  text-decoration: none;
  font-weight: 800;
  font-size: 1.1rem;
  transition: color 0.2s;
}

.secondary-link:hover {
  color: #bfa14d;
}

@media (max-width: 768px) {
  .why-matters {
    padding: 80px 20px;
  }
  .benefit-card {
    padding: 40px 20px;
  }
}
</style>
